"use strict";
import { getAddress } from "@ethersproject/address";
import { logger } from "utilities/src/logger/logger";
export var AddressStringFormat = /* @__PURE__ */ ((AddressStringFormat2) => {
  AddressStringFormat2[AddressStringFormat2["Lowercase"] = 0] = "Lowercase";
  AddressStringFormat2[AddressStringFormat2["Uppercase"] = 1] = "Uppercase";
  AddressStringFormat2[AddressStringFormat2["Shortened"] = 2] = "Shortened";
  return AddressStringFormat2;
})(AddressStringFormat || {});
export function getValidAddress(address, withChecksum = false, log = true) {
  try {
    if (!address) {
      return null;
    }
    const addressWith0x = ensureLeading0x(address.trim());
    if (withChecksum) {
      return getAddress(addressWith0x);
    }
    if (addressWith0x.length !== 42) {
      throw new Error("Address has an invalid format");
    }
    return normalizeAddress(addressWith0x, 0 /* Lowercase */);
  } catch (error) {
    if (log) {
      logger.warn("utils/addresses", "getValidAddress", error?.message, {
        data: address,
        stacktrace: new Error().stack
      });
    }
    return null;
  }
}
export function normalizeAddress(address, format) {
  switch (format) {
    case 0 /* Lowercase */:
      return address.toLowerCase();
    case 1 /* Uppercase */:
      return address.toUpperCase();
    case 2 /* Shortened */:
      return address.substr(0, 8);
    default:
      throw new Error(`Invalid AddressStringFormat: ${format}`);
  }
}
export function sanitizeAddressText(address) {
  const zws = "\u200B";
  return address?.replace("x", `x${zws}`);
}
export function areAddressesEqual(a1, a2) {
  const validA1 = getValidAddress(a1);
  const validA2 = getValidAddress(a2);
  return validA1 !== null && validA2 !== null && validA1 === validA2;
}
export function ensureLeading0x(input) {
  return input.startsWith("0x") || input.startsWith("0X") ? input : `0x${input}`;
}
